import Modules from 'shared_modules/Modules';

// remove and special characters and then replace any spaces in the string with underscore
const cleanUpString = (str: string) => {
  if (!str || str.length === 0) {
    return '';
  }
  // replace any spaces in the string with underscore
  const cleanedString = str.replace(/\s+/g, '_');
  // remove any special characters from the string
  return cleanedString.replace(/[^a-zA-Z0-9.-_\s]/g, '');
};

export function trackAnalyticsEvent({
  eventCategory,
  eventName,
  eventAction,
  eventValue = '',
  eventLabel = '',
}: {
  eventCategory: string;
  eventName: string;
  eventAction: string;
  eventValue?: any; // truly can be any type, typically a number or string but could be an Object
  eventLabel?: string;
}) {
  if (!Modules.hasModule('analytics.initiative.tracking')) {
    return;
  }

  const url = '/admin/analytics/track';
  const urlSuffix = `/${cleanUpString(eventCategory)}.${cleanUpString(eventName)}.${cleanUpString(
    eventAction
  )}${eventLabel && `.${cleanUpString(eventLabel)}`}`;

  fetch(`${url}${urlSuffix}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      eventCategory,
      eventName,
      eventAction,
      eventValue,
      eventLabel,
    }),
  });
}
